<template>
  <NewShopNoWebhookChat />
</template>
<script>
import NewShopNoWebhookChat from "@/components/NewShopNoWebhookChat";
export default {
  components: {
    NewShopNoWebhookChat
  }
}
</script>